module.exports = __webpack_public_path__ + "img/20_dice[11].34ff1287.png";